import React, { useState, useEffect } from "react";
import { Grid, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { IoEye, IoEyeOff } from "react-icons/io5";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import { GreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import SideBar from "./index";
import { PostMethod } from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader"
import {encryptData } from "../../Helper/Encryptions"

const ChangePassword = () => {

  const [passwords, setPasswords] = useState({
    exisitingPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    exisitingPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [NewWeak, setNewWeak] = useState(false);
  const [NewMedium, setNewMedium] = useState(false);
  const [NewStrong, setNewStrong] = useState(false);
  const [ConfirmWeak, setConfirmWeak] = useState(false);
  const [ConfirmMedium, setConfirmMedium] = useState(false);
  const [ConfirmStrong, setConfirmStrong] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false);
  const [ipaddress, setipaddress] = useState("");

  const strongRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&,[\]){}}(^+{#}=_-]{8,}$/;
  const mediumRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*?&,[\]({)}^+{#}=_-]{6,}$/;

  const HandleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const RegiterationSubmit = (e) => {
    e.preventDefault();
  };

  const handleToggleVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(()=>{
    GetIpaddress()
  },[])
  const GetIpaddress =async()=>{
    try{
      const response =await fetch("https://api.ipify.org/")
      const data =await response.text()
      setipaddress(data)
    }catch(Error){
      console.log("err in GetIpaddress",Error)
    }
  }
  const HandleNewPassword = () => {
    if (passwords.newPassword.trim().length > 0) {
      setNewWeak(true);
    }
    if (mediumRegex.test(passwords.newPassword)) {
      setNewMedium(true);
    }
    if (!mediumRegex.test(passwords.newPassword)) {
      setNewMedium(false);
    }
    if (strongRegex.test(passwords.newPassword)) {
      setNewStrong(true);
    }
    if (!strongRegex.test(passwords.newPassword)) {
      setNewStrong(false);
    }
  };

  const HandleConfirmPassword = () => {
    if (passwords.confirmPassword.trim().length > 0) {
      setConfirmWeak(true);
    }
    if (mediumRegex.test(passwords.confirmPassword)) {
      setConfirmMedium(true);
    }
    if (!mediumRegex.test(passwords.confirmPassword)) {
      setConfirmMedium(false);
    }
    if (strongRegex.test(passwords.confirmPassword)) {
      setConfirmStrong(true);
    }
    if (!strongRegex.test(passwords.confirmPassword)) {
      setConfirmStrong(false);
    }
  };

  const ValidatePassword = (password) => {
    var passwordValidation =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return passwordValidation.test(password);
  };
  const UpdateValidation = async() => {
    try {
      if (!passwords.exisitingPassword) {
        toast.warn("Exisiting Password Can't Be Empty");
        return;
      }
      if (!passwords.newPassword) {
        toast.warn("Password Field Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.newPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character"
        );
        return;
      }
      if (!passwords.confirmPassword) {
        toast.warn("Confirm Password Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.confirmPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character"
        );
        return;
      }
      if (passwords.newPassword !== passwords.confirmPassword) {
        toast.warn("Passwords Mismatched");
        return;
      }
      const userid = localStorage.getItem("@users");
      const users = JSON.parse(userid)
      if(!users?.email){
        toast.error("Something went wrong please try again later")
        return
      }
      let url ="candidate/changepassword"
      let method ="PUT"
      let params ={
        "email":encryptData(users.email),
        "password":encryptData(passwords.exisitingPassword),
        "newpasswords":encryptData(passwords.confirmPassword),
        "ipaddress":ipaddress
      }
      setShowLoader(true)
      const response =await PostMethod({url,method,params})
      if(response.status){
        setShowLoader(false)
        setPasswords({
          exisitingPassword: "",
          newPassword: "",
          confirmPassword: "",
        })
        setShowPassword({
          exisitingPassword: false,
          newPassword: false,
          confirmPassword: false,
        })
        toast.success("Password updated successfully")
      }else{
        setShowLoader(false)
        if(response.message){
          toast.error(response.message)
        }else{
          toast.error("Something went wrong please try again later")
        }
      }
    } catch (err) {
      setShowLoader(false)
      toast.error("Something went wrong please try again later")
      console.log("err in LoginValidation", err);
    }
  };

  useEffect(() => {
    HandleNewPassword(passwords.newPassword);
    HandleConfirmPassword(passwords.confirmPassword);
  }, [passwords.newPassword, passwords.confirmPassword]);

  return (
    <Grid item container>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
      <Grid item container justifyContent={"space-between"} className="mt-3">
        <Grid item container lg={3} md={3} sm={12} className="bg-white p-3 borderRadius10" alignSelf={"baseline"} flexDirection={"column"} alignItems={"flex-start"}>
          <SideBar />
        </Grid>
        <Grid item container lg={8.8} md={8.8} sm={12} className="bg-white p-3 borderRadius10">
          <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">Change Password</h4>
          <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          <Grid item lg={12} md={12} sm={12} xs={12} container>
            <form
              style={{ width: "100%", display: "contents" }}
              className="loginregister"
              onSubmit={RegiterationSubmit}
            >
              <Grid container>
                <p className=" poppinsMedium Text-Prime-Black pt-3">
                  Exisiting Password
                </p>
                <CustomInput
                  placeholder="Enter Exisiting Password"
                  type={showPassword.exisitingPassword ? "text" : "password"}
                  backgroundColor="#FFFFFF"
                  width={"100%"}
                  height={"45px"}
                  placeholderColor={"#666666"}
                  padding={"2.5% 2% 2.5% 0%"}
                  border={"1px solid  #666666"}
                  fontFamily={"PoppinsMedium"}
                  maxLength={50}
                  marginTop={"1%"}
                  value={passwords.exisitingPassword}
                  InputProps={showPassword.exisitingPassword ? (
                    <IoEye
                      className="eyeIcons pointer"
                      onClick={() => handleToggleVisibility("exisitingPassword")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  ) : (
                    <IoEyeOff
                      className="eyeIcons pointer"
                      onClick={() => handleToggleVisibility("exisitingPassword")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  )}
                  onChange={(e) => handleChange("exisitingPassword", e.target.value)}
                />
              </Grid>
              <Grid container>
                <p className=" poppinsMedium Text-Prime-Black pt-3">New Password</p>
                <CustomInput
                  placeholder="Enter New Password"
                  type={showPassword.newPassword ? "text" : "password"}
                  placeholderColor={"#666666"}
                  backgroundColor="#FFFFFF"
                  width={"100%"}
                  height={"45px"}
                  padding={"2.5% 2% 2.5% 0%"}
                  border={"1px solid  #666666"}
                  fontFamily={"PoppinsMedium"}
                  maxLength={50}
                  marginTop={"1%"}
                  value={passwords.newPassword}
                  InputProps={showPassword.newPassword ? (
                    <IoEye
                      className="eyeIcons pointer"
                      onClick={() => handleToggleVisibility("newPassword")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  ) : (
                    <IoEyeOff
                      className="eyeIcons pointer"
                      onClick={() => handleToggleVisibility("newPassword")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  )}
                  onChange={(e) => handleChange("newPassword", e.target.value)}
                />
              </Grid>
              <Grid
                container
                lg={12}
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                className="mt-2"
              >
                <Grid
                  item
                  lg={3.5}
                  md={3.5}
                  sm={3.5}
                  xs={3.5}
                  height={"30px"}
                >
                  <Grid
                    container
                    lg={12}
                    className="p-1 rounded"
                    sx={{
                      backgroundColor: !NewWeak ? "#E0E0E0" : "#E62A4A",
                    }}
                  ></Grid>
                  {NewWeak && (
                    <p
                      className="text-center mt-1 poppinsRegular fontSize12"
                      style={{ color: "#E62A4A" }}
                    >
                      {" "}
                      Weak
                    </p>
                  )}
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={3.5}
                  sm={3.5}
                  xs={3.5}
                  height={"30px"}
                >
                  <Grid
                    container
                    lg={12}
                    className="p-1 rounded"
                    sx={{
                      backgroundColor: !NewMedium ? "#E0E0E0" : "#E9B229",
                    }}
                  ></Grid>
                  {NewMedium && (
                    <p
                      className="text-center mt-1 poppinsRegular fontSize12"
                      style={{ color: "#E9B229" }}
                    >
                      {" "}
                      Medium
                    </p>
                  )}
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={3.5}
                  sm={3.5}
                  xs={3.5}
                  height={"30px"}
                >
                  <Grid
                    container
                    lg={12}
                    className="p-1 rounded"
                    sx={{
                      backgroundColor: !NewStrong ? "#E0E0E0" : "#52BD94",
                    }}
                  ></Grid>
                  {NewStrong && (
                    <p
                      className="text-center mt-1 poppinsRegular fontSize12"
                      style={{ color: "#52BD94" }}
                    >
                      {" "}
                      Strong
                    </p>
                  )}
                </Grid>
              </Grid>
              <Grid container>
                <p className=" poppinsMedium Text-Prime-Black">Confirm Password</p>
                <CustomInput
                  placeholder="Enter Your Confirm Password"
                  type={showPassword.confirmPassword ? "text" : "password"}
                  placeholderColor={"#666666"}
                  backgroundColor="#FFFFFF"
                  width={"100%"}
                  height={"45px"}
                  padding={"2.5% 2% 2.5% 0%"}
                  border={"1px solid  #666666"}
                  fontFamily={"PoppinsMedium"}
                  maxLength={50}
                  marginTop={"1%"}
                  value={passwords.confirmPassword}
                  InputProps={showPassword.confirmPassword ? (
                    <IoEye
                      className="eyeIcons pointer"
                      onClick={() => handleToggleVisibility("confirmPassword")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  ) : (
                    <IoEyeOff
                      className="eyeIcons pointer"
                      onClick={() => handleToggleVisibility("confirmPassword")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  )}
                  onChange={(e) => handleChange("confirmPassword", e.target.value)}
                />

              </Grid>
              <Grid
                container
                lg={12}
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                className="mt-2"
              >
                <Grid
                  item
                  lg={3.5}
                  md={3.5}
                  sm={3.5}
                  xs={3.5}
                  height={"30px"}
                >
                  <Grid
                    container
                    lg={12}
                    className="p-1 rounded"
                    sx={{
                      backgroundColor: !ConfirmWeak ? "#E0E0E0" : "#E62A4A",
                    }}
                  ></Grid>
                  {ConfirmWeak && (
                    <p
                      className="text-center mt-1 poppinsRegular fontSize12"
                      style={{ color: "#E62A4A" }}
                    >
                      {" "}
                      Weak
                    </p>
                  )}
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={3.5}
                  sm={3.5}
                  xs={3.5}
                  height={"30px"}
                >
                  <Grid
                    container
                    lg={12}
                    className="p-1 rounded"
                    sx={{
                      backgroundColor: !ConfirmMedium ? "#E0E0E0" : "#E9B229",
                    }}
                  ></Grid>
                  {ConfirmMedium && (
                    <p
                      className="text-center mt-1 poppinsRegular fontSize12"
                      style={{ color: "#E9B229" }}
                    >
                      {" "}
                      Medium
                    </p>
                  )}
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={3.5}
                  sm={3.5}
                  xs={3.5}
                  height={"30px"}
                >
                  <Grid
                    container
                    lg={12}
                    className="p-1 rounded"
                    sx={{
                      backgroundColor: !ConfirmStrong ? "#E0E0E0" : "#52BD94",
                    }}
                  ></Grid>
                  {ConfirmStrong && (
                    <p
                      className="text-center mt-1 poppinsRegular fontSize12"
                      style={{ color: "#52BD94" }}
                    >
                      {" "}
                      Strong
                    </p>
                  )}
                </Grid>
              </Grid>
              <Grid container flexDirection={"column"} alignItems={"flex-start"} className="pt-4">
                <p className=" poppinsMedium text-black fontSize14 text-left">For security, your new password should contain:</p>
                <p className=" poppinsRegular text-black fontSize14 pt-1 text-left">1. At least 8 characters</p>
                <p className=" poppinsRegular text-black fontSize14 pt-1 text-left">2. A mix of letters, numbers, and symbols</p>
              </Grid>
              <Grid container justifyContent={"center"} className="pt-5">
                <GreenColorButton
                  type="submit"
                  className="px-5 py-2"
                  onClick={() => UpdateValidation()}
                >
                  Change Password
                </GreenColorButton>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;